import React from 'react';
import 'animate.css'; // Import Animate.css for animations
import icon1 from '../assets/images/client/icon1.png';
import icon2 from '../assets/images/client/icon2.png';
import icon3 from '../assets/images/client/icon3.png';
import icon4 from '../assets/images/client/icon4.png';
import icon5 from '../assets/images/client/icon5.png';
import icon6 from '../assets/images/client/icon6.png';
import icon7 from '../assets/images/client/icon7.png';
import icon8 from '../assets/images/client/icon8.jpg';
import leads from '../assets/images/leads.png';
import dataDriven from '../assets/images/data-driven.png';
import funnel from '../assets/images/funnel.png';
import partnership from '../assets/images/partnership.png';
import report from '../assets/images/report.png';
import market from '../assets/images/market.png';
import strategy2 from '../assets/images/strategy2.jpeg';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Autoplay, Navigation } from 'swiper/modules';


const clientIcons = [icon8, icon1, icon3, icon4, icon5, icon6, icon2, icon1, icon3, icon4, icon5, icon7, icon2]; // Add more for demo

const HomeContent = () => {

    return (
        <>
        <section className="bg-white dark:bg-gray-900 mt-2 lg:mt-0 clear-both">
            <div className="gap-8 items-center py-8 px-4 mx-auto max-w-screen-xl lg:grid lg:grid-cols-2 lg:py-16 lg:px-6">
                <div className="font-light sm:text-lg">
                    <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-300">A little About us</h3>
                    <h2 className="mb-4 text-3xl md:text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">
                        Empowering Communities Together
                    </h2>
                    <p className="mb-4 text-gray-600 dark:text-gray-400">
                        AdSki is a performance marketing agency committed to helping lead-generation businesses scale efficiently. Based in Kanpur, we bring together a team of passionate marketers, designers, and strategists who understand what it takes to generate high-quality leads for service-based businesses. Our mission is to create result-oriented marketing strategies that drive traffic, generate leads, and maximize conversions. With a customer-first approach, we tailor each campaign to meet your unique business goals, ensuring measurable success and long-term growth.
                    </p>
                </div>
                <div className="grid mt-8">
                    <img className="w-full rounded-lg" src={strategy2} alt="office content 1" />
                </div>
            </div>
        </section>

        <div className='clear-both'></div>

        <section className="bg-gradient-to-r from-gray-100 to-gray-200 text-center container mx-auto py-12">
            <div className="mx-auto max-w-screen-xl px-4">
                <h2 className="text-3xl md:text-4xl font-extrabold tracking-tight leading-tight text-center text-blue-900 pb-6">
                    Our Esteemed Clients
                </h2>
                <div className="relative">
                    <Swiper
                        modules={[Navigation, Autoplay]}
                        navigation={false}
                        autoplay={{ delay: 2000, disableOnInteraction: false }}
                        spaceBetween={20}
                        slidesPerView={2}
                        breakpoints={{
                            640: { slidesPerView: 3 },
                            1024: { slidesPerView: 6 },
                        }}
                        loop={true}
                    >
                        {clientIcons.map((icon, index) => (
                            <SwiperSlide key={index}>
                                <div className="flex justify-center items-center p-4 transform hover:scale-105 transition-all duration-300">
                                    <img className="w-full sm:w-full sm:h-20 object-contain rounded-lg" src={icon} alt={`Client${index + 1}`} />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>

        <section className='lg:my-0 md:my-0 my-8 text-black dark:text-balck'>
            <div className="px-4 mx-auto max-w-screen-xl sm:py-16 lg:px-6">
                <div className="max-w-screen-lg mb-8 lg:mb-16 text-center mx-auto">
                    <h2 className="mb-4 text-3xl md:text-4xl tracking-tight font-extrabold">
                        WHY YOU SHOULD CHOOSE US?
                    </h2>
                    <p className="sm:text-lg dark:text-gray-400">
                        At AdSki, we go beyond conventional marketing tactics to deliver measurable results. Here's why businesses trust us for their lead generation and performance marketing needs:
                    </p>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
                    {[
                        { img: leads, title: "Lead Generation Experts", desc: "We specialize in high-quality leads for businesses, ensuring a steady flow of potential customers." },
                        { img: dataDriven, title: "Data-Driven Approach", desc: "Our strategies are continuous optimization, and performance tracking to maximize ROI." },
                        { img: market, title: "Customized Marketing Solutions", desc: "No one-size-fits-all approach—each campaign is tailored to meet your business objectives." },
                        { img: funnel, title: "Full-Funnel Optimization", desc: "From ad creation to landing pages, we optimize every step of the customer journey to boost conversions." },
                        { img: report, title: "Transparent Reporting", desc: "Real-time insights and clear performance metrics so you always know where your budget is going." },
                        { img: partnership, title: "Customer Success", desc: "Resolve all support issues with ease. Monitor incoming tickets and set priorities for different issues." }
                    ].map((item, index) => (
                        <div key={index} className="flex flex-col items-center text-center ">
                            <img src={item.img} alt={item.title} className='w-16 sm:w-20 mb-4' />
                            <h3 className="mb-2 text-lg sm:text-xl font-bold dark:text-black">{item.title}</h3>
                            <p className="text-gray-500 dark:text-gray-400 text-sm sm:text-base">
                                {item.desc}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
        </>
    );
}

export default HomeContent